export default __webpack_public_path__ + "static/media/330_business04-fr-mobile.a8799c20.png";